import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { FeatureZedsModule } from '@netfoundry-ui/feature-zeds';

import { FeatureGettingStartedModule } from '@netfoundry-ui/feature/getting-started';
import { ConfigTitleBarComponent } from './zeds-config/config-title-bar/config-title-bar.component';
import { ZedsConfigComponent } from './zeds-config/zeds-config.component';
import { ButtonBarComponent } from './zeds-create/button-bar/button-bar.component';
import { CreateAppTitleBarComponent } from './zeds-create/create-app-title-bar/create-app-title-bar.component';
import { ZedsCreateComponent } from './zeds-create/zeds-create.component';
import { ManageAppTitleBarComponent } from './zeds-manage/manage-app-title-bar/manage-app-title-bar.component';
import { ZedsManageComponent } from './zeds-manage/zeds-manage.component';
import { AppMenuComponent } from './app-menu/app-menu.component';
import { ZedsGettingStartedComponent } from './zeds-getting-started/zeds-getting-started.component';
import { GettingStartedTitleBarComponent } from './zeds-getting-started/getting-started-title-bar/getting-started-title-bar.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        FeatureZedsModule,
        BrowserAnimationsModule,
        MatIconModule,
        MatMenuModule,
        MatButtonModule,
        MatDialogModule,
        MatTooltipModule,
        FeatureGettingStartedModule,
    ],
    declarations: [
        ZedsCreateComponent,
        ZedsManageComponent,
        ZedsConfigComponent,
        ZedsGettingStartedComponent,
        ButtonBarComponent,
        CreateAppTitleBarComponent,
        ManageAppTitleBarComponent,
        ConfigTitleBarComponent,
        AppMenuComponent,
        GettingStartedTitleBarComponent,
    ],
    exports: [ZedsCreateComponent, ZedsManageComponent, ZedsConfigComponent],
})
export class PageZedsModule {}
